import { createSlice } from '@reduxjs/toolkit';

export const selectedGroupSlice = createSlice({
  name: 'selectedGroup',
  initialState: { group: null },
  reducers: {
    selectGroup: (state, action) => {
      state.group = action.payload;
    },
    deselectGroup: (state, action) => {
      state.group = null;
    },
  },
});

// Extract the action creators object and the reducer from the slice
export const { actions, reducer } = selectedGroupSlice;
export default reducer;

// Extract and export each action creator by name
export const {
  selectGroup,
  deselectGroup,
} = actions;
